import { render, staticRenderFns } from "./StoriesTable.vue?vue&type=template&id=48539160"
import script from "./StoriesTable.vue?vue&type=script&lang=js"
export * from "./StoriesTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports